import React from 'react'
import { classNames } from 'src/lib/utils/helpers'

// Each surface the app/integration works with gets its own coloured tag.
const TAG_STYLES: Record<string, { label: string; className: string }> = {
  CHECKOUT: { label: 'Checkout', className: 'bg-emerald-100 text-emerald-700' },
  CART: { label: 'Cart', className: 'bg-sky-100 text-sky-700' },
  SHOPPASS: { label: 'ShopPass', className: 'bg-violet-100 text-violet-700' },
  SHOP_PASS: { label: 'ShopPass', className: 'bg-violet-100 text-violet-700' },
  PDP: { label: 'PDP', className: 'bg-pink-100 text-pink-700' }
}

const toTitleCase = (value: string) =>
  value
    .toLowerCase()
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')

const WorksWithTags: React.FC<{ items?: string[] }> = ({ items }) => {
  if (!items?.length) return null

  return (
    <span className='flex flex-wrap items-center gap-1.5'>
      {items.map(raw => {
        const style = TAG_STYLES[raw.toUpperCase()]
        return (
          <span
            key={raw}
            className={classNames(
              'inline-flex items-center rounded-sm px-1.5 text-text-xs-medium',
              style?.className ?? 'bg-zinc-100 text-zinc-700'
            )}
          >
            {style?.label ?? toTitleCase(raw)}
          </span>
        )
      })}
    </span>
  )
}

export default WorksWithTags
